import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-community-touch.png'

const paperInfo = {
  paperName: 'コミュニティタッチ概論',
  thumbnail,
  feature1: 'コミュニティタッチとは何か',
  feature2: 'なぜいまコミュニティタッチなのか',
  feature3: 'コミュニティタッチの分類と事例',
  description:
    'いま注目される「コミュニティタッチ」とはどのようなものか、なぜ今重要なのか、そして企業がどのようにして活用するのか、について豊富な事例をもとに解説いたします。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-03-06/g81',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
